import React, { useMemo } from 'react';

import { KeyManagerSport } from 'features/sport';
import { ScommesseGroupWrapper } from 'components/scommesseTipo/wrappers/scommesseGroupWrapper';
import { ScommesseLeafItem } from 'components/scommesseTipo/components/cells';
import { ScommesseTipoProps } from 'components/scommesseTipo/types';
import { SkeletonCell } from 'components/scommesseTipo/components/cells/SkeletonCell';
import { calculateBoxNumber } from 'components/scommesseTipo';
import { useInfoTipo } from 'features/sport/hooks';

export const Skeleton = (props: ScommesseTipoProps) => {
  const { scommessaKey } = props;

  const { tipoScommessaId } = useMemo(() => new KeyManagerSport(scommessaKey), [scommessaKey]);
  const infoTipoScommessa = useInfoTipo(tipoScommessaId);

  return (
    <>
      {/* <ScommesseGroupWrapper scommessaKey={scommessaKey}> */}
      {calculateBoxNumber(infoTipoScommessa).map(({ header, headerTrKey, size, isInfoAgg }, index) => (
        <SkeletonCell
          key={`${headerTrKey}-${index}`}
          size={size}
          type={isInfoAgg ? ScommesseLeafItem.InfoAggiuntiva : ScommesseLeafItem.Esito}
          itemKey={`${scommessaKey}-${index}`}
          scommessaKey={scommessaKey}
          infoAggiuntivaKey={scommessaKey}
          header={header}
          headerTrKey={headerTrKey}
        />
      ))}
    </>
  );
};